import type { OverdriveView } from "../events/overdrive";
import {
  startReactorStorm,
  stopReactorStormEarly,
  type ReactorStormRuntimeState
} from "../events/reactor-storm";
import type { ProfileProgress } from "../progression/levels";
import type { OrbitForgeSave } from "../save/types";
import type { FeedbackDraft } from "./feedback";

export interface StormControlInput {
  readonly save: OrbitForgeSave;
  readonly progress: ProfileProgress;
  readonly overdrive: OverdriveView;
  readonly state: ReactorStormRuntimeState | null;
  readonly stopConfirmSeconds: number;
}

export interface StormControlResult {
  readonly state: ReactorStormRuntimeState | null;
  readonly stopConfirmSeconds: number;
  readonly dirty: boolean;
  readonly feedback: readonly FeedbackDraft[];
}

export function runStormControl(input: StormControlInput): StormControlResult {
  if (input.state) {
    if (input.stopConfirmSeconds > 0) {
      const stopped = stopReactorStormEarly();
      return {
        state: stopped.state,
        stopConfirmSeconds: 0,
        dirty: stopped.dirty,
        feedback: stopped.feedback
      };
    }

    return {
      state: input.state,
      stopConfirmSeconds: 2,
      dirty: false,
      feedback: [{ kind: "floating-text", target: "storm", frameX: 1690, frameY: 348, color: "white", text: "CLICK AGAIN TO STOP" }]
    };
  }

  const started = startReactorStorm(input.save, input.progress, input.overdrive);
  return {
    state: started.state,
    stopConfirmSeconds: 0,
    dirty: started.dirty,
    feedback: started.feedback
  };
}
